// Display catalogue: known puzzle types and the emissive recipe per category.

export const KNOWN_TYPES = [
  "pattern.matrix",
  "pattern.odd_one_out",
  "pattern.figure_series",
  "pattern.visual_analogy",
  "number.sequence",
  "number.quick_calc",
  "number.symbol_equation",
  "number.balance_scale",
  "spatial.mental_rotation",
  "spatial.block_count",
  "spatial.cube_net",
  "logic.line_matrix",
  "logic.region_count",
  "logic.code_breaker",
  "memory.grid_flash",
  "memory.sequence_recall",
  "speed.odd_shade",
  "speed.stroop",
  "planning.shortest_path",
  "word.letter_sequence",
  "word.anagram",
] as const;

/** Category -> tiles.css recipe (used for level tracks and chapter art). */
export const CATEGORY_TILE: Record<string, string> = {
  pattern: "violet",
  number: "azure",
  spatial: "teal",
  logic: "magenta",
  memory: "home-teams",
  speed: "ember",
  planning: "moss",
  word: "rose",
  mixed: "violet-home",
};

/** Palette names as written in specs/packs (camelCase token keys) -> tiles.css class suffix. */
export const tileClass = (palette: string | null | undefined, fallback = "violet") =>
  `tile-${(palette || fallback).replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase()}`;
